module.exports = __webpack_public_path__ + "static/media/Nika.02dc28dc.jpg";